import './style.scss';

import { Button } from '@wordpress/components';
import classNames from 'classnames';
import React from 'react';

import { type ButtonGroupProps } from './types';

export const ButtonGroup: React.FC< ButtonGroupProps > = ( {
	value,
	options,
	onChange,
	allowDeselect = true,
	className = '',
} ) => {
	const handleClick = ( optionValue: string | undefined ) => {
		if ( ! onChange ) return;

		if ( allowDeselect && value === optionValue ) {
			// Deselect if clicking on already selected option
			onChange( undefined );
		} else {
			onChange( optionValue );
		}
	};

	return (
		<div
			className={ classNames(
				{ 'redfox-thank-you-button-group': true },
				className,
			) }
		>
			{ options.map( ( option, index ) => {
				const isSelected = value === option.value;
				const keyValue =
					option.value !== undefined
						? `${ option.value }-${ index }`
						: `undefined-${ index }`;
				return (
					<Button
						key={ keyValue }
						className={ classNames( {
							'redfox-thank-you-button-group__button': true,
							'is-selected': isSelected,
						} ) }
						onClick={ () => handleClick( option.value ) }
						variant={ isSelected ? 'primary' : 'secondary' }
						size="small"
						icon={ option.icon }
						iconSize={option.iconSize || 18}
						title={ option.label }
						aria-label={ option.label }
						aria-pressed={ isSelected }
					>
						{ ! option.icon && option.label }
					</Button>
				);
			} ) }
		</div>
	);
};
